/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  isDownloading: boolean
}
export namespace State {
  export const INITIAL: State = {
    isDownloading: false,
  }
}
